export var DocsBlockTextPropertyColor;
(function (DocsBlockTextPropertyColor) {
    /** Default color for text */
    DocsBlockTextPropertyColor["neutral"] = "Neutral";
    /** Slightly lighter color than default neutral color */
    DocsBlockTextPropertyColor["neutralFaded"] = "NeutralFaded";
})(DocsBlockTextPropertyColor || (DocsBlockTextPropertyColor = {}));
